import { useSelector } from 'react-redux';
import { get } from 'lodash';

const useDataBackupStatus = () => useSelector((state) => get(state, 'storeStage.isDataBackuped', false));

export { useDataBackupStatus };
